/**
 * Prins: Components > Manifest
 *
 * @copyright 2023 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {
	SelectorEngine,
	EventHandler
} from '@ifabnpm/bootstrap/dom.js';

import Button from '@ifabnpm/bootstrap/component/button.js';
import Details from '@ifabnpm/bootstrap/component/details.js';
import TabGroup from '@ifabnpm/bootstrap/component/tab-group.js';
import Tag from '@ifabnpm/bootstrap/component/tag.js';
import RevealPassword from '@ifabnpm/bootstrap/component/reveal-password.js';
// import Reveal from '@ifabnpm/bootstrap/component/reveal.js';
// import Slider from '@ifabnpm/bootstrap/component/slider.js';
// import Form from '@ifabnpm/bootstrap/component/form.js';
// import Jumplist from '@ifabnpm/bootstrap/component/jumplist.js';
// import List from '@ifabnpm/bootstrap/component/list.js';
// import MediaGallery from '@ifabnpm/bootstrap/component/media-gallery.js';
// import Player from '@ifabnpm/bootstrap/component/player.js';
// import ProgressBar from '@ifabnpm/bootstrap/component/progress-bar.js';
// import ProgressRing from '@ifabnpm/bootstrap/component/progress-ring.js';
// import Spinner from '@ifabnpm/bootstrap/component/spinner.js';

import Autocomplete from './custom/autocomplete';
import Card from './overwrites/shared/card';
import Drawer from './overwrites/shared/drawer';
import Form from './overwrites/shared/form';
import Notification from './custom/notification';
import Choices from './custom/choices';
import DateTimePicker from "./custom/date-time-picker";
import FilterList from './custom/filter-list';
import MultiSelect from './custom/multi-select';
import SwitchView from './custom/switch-view';
import Rte from './custom/rte';
import Modal from './custom/modal';
import UploadPreview from './custom/upload-preview';
import Sortable from './custom/sortable';
import {init as RecordGroupInit} from './custom/record-group';
// import AutoValue from "./overwrites/shared/form/tools/auto-value";
import NestedRecords from './custom/nested-records';

// JS-Snippets die vorerst nicht sortierbar sind.
import Snippets from './custom/snippets';

// ------
// Public
// ------

const components = () => {
	Notification();
	Modal.init();
	Button.init();
	Card.init();
	// List.init();
	Details.init();
	// Slider.init();
	TabGroup.init();
	// Player.init();
	// MediaGallery.init();
	Drawer.init();
	// Jumplist.init();
	// ScrollProgress.init();

	Form.init();
	Choices.init();
	DateTimePicker.init();
	FilterList.init();
	MultiSelect.init();
	SwitchView.init();
	Rte.init();
	Tag.init(null, {
		removeCtrlLabel: window.Prins.tm.translate('remove')
	});
	RevealPassword.init();
	Autocomplete.init();

	//
	// Upload preview initialisieren.
	//

	const collectionFile = SelectorEngine.find('[data-upload-preview]');

	if (collectionFile.length > 0) {
		for (const element of collectionFile) {
			new UploadPreview(element, {
				preview : {
					alt: (window.Prins.tm) ? window.Prins.tm.translate('preview') : 'Preview',
				},
				add     : {
					label: (window.Prins.tm) ? window.Prins.tm.translate('selectFile') : 'Select file',
					text : (window.Prins.tm) ? window.Prins.tm.translate('selectFile') : 'Select file'
				},
				remove  : {
					label: (window.Prins.tm) ? window.Prins.tm.translate('removeFile') : 'Remove file',
					text : (window.Prins.tm) ? window.Prins.tm.translate('removeFile') : 'Remove file'
				},
				onRemove: (event) => {
					// Formularänderung dem Elternformular bekannt geben!
					const form = SelectorEngine.parents(event.element, 'form')[0];

					if (form) {
						EventHandler.trigger(form, 'changeDetected');
					}
				}
			});
		}
	}

	// ProgressBar.init();
	// ProgressRing.init();
	// RevealPassword.init();
	// Reveal.init();

	// TODO (JS), Sortierung ´Drag'n'Drop´ aktivieren.
	Sortable.init();
	RecordGroupInit();

	NestedRecords.init();

	// JS-Snippets die vorerst nicht sortierbar sind.
	Snippets();

	// const form = SelectorEngine.findOne('#exampleallfields-126');
	//
	// if (form) {
	// 	EventHandler.on(form, 'init.ifab.nfv', event => {
	// 		console.log('EV:init.ifab.nfv', event);
	// 	});
	// 	EventHandler.on(form, 'validationFailed.ifab', event => {
	// 		console.log('EV:validationFailed.ifab', event);
	// 	});
	// 	EventHandler.on(form, 'validationSuccess.ifab', event => {
	// 		console.log('EV:validationSuccess.ifab', event);
	// 	});
	//
	// 	Form.nativeFormValidation(form, {
	// 		onInit   : (event) => {
	// 			console.log('OPT:onInit', event);
	// 		}, // noop,
	// 		onValidationFailed: (event) => {
	// 			console.log('OPT:onValidationFailed', event);
	// 		}, // noop,
	// 		onValidationSuccess  : (event) => {
	// 			console.log('OPT:onValidationSuccess', event);
	// 		} // noop
	// 	});
	// }

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	// 	GMap.init(null, {
	// 		apiKey  : window.pageInstance.settings.maps.google.id,
	// 		settings: {
	// 			// Siehe google-maps.js -> DEFAULTS
	// 			map: {
	// 				zoom: 14
	// 			}
	// 		}
	// 	});
	// }
};

// Export
export default components;
